module.exports = __webpack_public_path__ + "img/undraw_texting_re_l11n.28d9fd86.svg";